import { getDefaultState } from './util'

const state = getDefaultState()
export default state
